export const SET_PARTNERS = "SET_PARTNERS";
export const SET_PARTNERS_ERROR = "SET_PARTNERS_ERROR";
export const SET_PARTNERS_LOADING = "SET_PARTNERS_LOADING";
export const SET_CREATED_PARTNER = "SET_CREATED_PARTNER";
export const SET_UPDATED_PARTNER = "SET_UPDATED_PARTNER";
export const REMOVE_DELETED_PARTNER = "REMOVE_DELETED_PARTNER";
export const SET_PARTNERS_FETCHING = "SET_PARTNERS_FETCHING";
